// @flow
import { css } from "styled-components";
import {
  TableWrapper,
  Table,
  AgentTH,
  ComparisonTH,
  TR,
  TD,
  IconTD,
} from "@nested/brand/src/components/ComparisonTable";
import { media, smallHeading, mediumHeading } from "@nested/brand";
import { NestedLogoHouseOnly } from "@nested/brand/src/icons";
import { Arrow } from "./Arrow";

const wrapperStyle = css`
  padding: 20px;
  background-color: white;
  ${media.desktop`
    background-color: ${({ theme }) => theme.palette.sand40};
    padding-bottom: 0px;
    padding-top: 56px;
  `}
`;

const headingStyle = css`
  ${smallHeading}
  margin: 0;
  text-align: center;
  white-space: nowrap;

  ${media.desktop`
    ${mediumHeading}
  `}
`;

const subheadingStyle = css`
  position: relative;
  display: inline-block;
  font-family: "Reenie Beanie";
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  line-height: 30px;
  margin-top: 11px;
  ${media.tablet`
    margin-top: 19px;
  `}
`;

const arrowWrapperStyle = css`
  position: absolute;
  bottom: 20%;
  left: calc(100% + 5px);

  ${media.desktop`
    bottom: 25%;
  `}
`;

const logoStyle = css`
  width: 13px;
`;

const tableStyle = css`
  margin-top: -40px;
  ${media.tablet`
    margin-top: 0px;
  `}
`;

const tableWrapperStyle = css`
  ${media.desktop`
    margin: auto;
    margin-top: 30px;
    max-width: 746px;
  `}
`;

const smallMarginStyle = css`
  transform: translate(0, 10px);
  ${media.desktop`
    transform: none;
  `}
`;

export const ComparisonTable = () => (
  <div css={wrapperStyle}>
    <h2 css={headingStyle}>
      Valuation feel wrong?
      <br />
      Get an accurate one from us
    </h2>
    <div css="text-align: center">
      <div css={subheadingStyle}>
        It's free and no obligation
        <div css={arrowWrapperStyle}>
          <Arrow />
        </div>
      </div>
    </div>
    <TableWrapper css={tableWrapperStyle}>
      <Table css={tableStyle}>
        <thead>
          <tr>
            <AgentTH
              css={`
                ${smallMarginStyle}
                white-space: normal;
              `}
            >
              Why get an in-person valuation?
            </AgentTH>
            <ComparisonTH css={smallMarginStyle}>Online</ComparisonTH>
            <ComparisonTH css={smallMarginStyle}>
              <NestedLogoHouseOnly css={logoStyle} /> Visit
            </ComparisonTH>
          </tr>
        </thead>
        <tbody>
          <TR>
            <TD>Personalised property report</TD>
            <IconTD value="No" />
            <IconTD value="Yes" />
          </TR>
          <TR>
            <TD>Similar properties for sale in the area</TD>
            <IconTD value="No" />
            <IconTD value="Yes" />
          </TR>
          <TR>
            <TD>Comparison of sales in the area over the last 12 months</TD>
            <IconTD value="No" />
            <IconTD value="Yes" />
          </TR>
          <TR>
            <TD>Comparison of property features and improvements made</TD>
            <IconTD value="No" />
            <IconTD value="Yes" />
          </TR>
          <TR>
            <TD>Expert knowledge of area and neighbourhood</TD>
            <IconTD value="No" />
            <IconTD value="Yes" />
          </TR>
          <TR>
            <TD>House price growth</TD>
            <IconTD value="Yes" />
            <IconTD value="Yes" />
          </TR>
          <TR>
            <TD>Last purchase price</TD>
            <IconTD value="Yes" />
            <IconTD value="Yes" />
          </TR>
        </tbody>
      </Table>
    </TableWrapper>
  </div>
);
